const getSupplierCity = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Address'] && business['Company Address'].City) {
    return business['Company Address'].City;
  }
  return null;
};

export default getSupplierCity;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierCity.js